import { useState } from "react";
import Icon from "../Icon";
import Campo from "./Campo";

// La confirmacion de un borrado que no se puede deshacer.
//
// Pide ESCRIBIR el nombre del proyecto. No es un trámite: un cuadro de dos
// botones se acepta con el mismo gesto con el que se acepta cualquier otro, y
// esta es la única acción de la aplicación que no tiene vuelta atrás. Teclear el
// nombre obliga a leer cuál es, que es justo el error que hay que evitar:
// borrar el proyecto de al lado.
//
// Y dice lo que se pierde y lo que NO, separado. Lo segundo importa tanto como
// lo primero: sin ello, nadie se atreve a pulsar por miedo a llevarse por
// delante las horas de su equipo.
export default function BorrarProyectoForm({ proyecto, inS, lbS, onBorrar, onClose }) {
  const [texto, setTexto] = useState("");
  const [enviando, setEnviando] = useState(false);
  const nombre = proyecto?.name || "";
  const coincide = texto.trim() === nombre.trim();

  const enviar = async () => {
    if (!coincide || enviando) return;
    setEnviando(true);
    await onBorrar();
  };

  return (
    <div>
      <div data-titulo="1" style={{ fontWeight: 800, fontSize: 16, marginBottom: 8, color: "var(--text)",
        display: "flex", alignItems: "center", gap: 8 }}>
        <Icon name="exclamation-triangle-fill" size={15} color="var(--red-text)" />
        Borrar «{nombre}» definitivamente
      </div>

      <div style={{ fontSize: 12.5, color: "var(--text3)", lineHeight: 1.6, marginBottom: 12 }}>
        Esto <b>no se puede deshacer</b>.
      </div>

      <div style={{ display: "grid", gap: 8, marginBottom: 16,
        gridTemplateColumns: "repeat(auto-fit,minmax(210px,1fr))" }}>
        <div style={{ background: "var(--red-bg)", border: "1px solid #fca5a5", borderRadius: 9,
          padding: "9px 11px" }}>
          <div style={{ fontSize: 9.5, fontWeight: 800, letterSpacing: ".06em",
            textTransform: "uppercase", color: "var(--red-text)", marginBottom: 4 }}>Se borra</div>
          <div style={{ fontSize: 11.5, color: "var(--text2)", lineHeight: 1.55 }}>
            El proyecto, sus pasos, las conexiones del flujo, sus miembros y todo su
            historial de cambios.
          </div>
        </div>
        <div style={{ background: "var(--ok-bg)", border: "1px solid #86efac", borderRadius: 9,
          padding: "9px 11px" }}>
          <div style={{ fontSize: 9.5, fontWeight: 800, letterSpacing: ".06em",
            textTransform: "uppercase", color: "var(--ok-text)", marginBottom: 4 }}>Se conserva</div>
          <div style={{ fontSize: 11.5, color: "var(--text2)", lineHeight: 1.55 }}>
            Las horas que cada uno imputó en su cuaderno, con el nombre del proyecto y
            del paso guardados en texto para que se sigan entendiendo.
          </div>
        </div>
      </div>

      <div className="cw-field" style={{ marginBottom: 18 }}>
        <Campo><label style={lbS}>Escribe «{nombre}» para confirmar</label>
        <input style={inS} value={texto} autoFocus
          placeholder={nombre}
          onChange={e => setTexto(e.target.value)}
          onKeyDown={e => e.key === "Enter" && enviar()} /></Campo>
      </div>

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button className="btn" onClick={onClose}
          style={{ padding: "8px 16px", borderRadius: 9, border: "1px solid var(--border)",
            cursor: "pointer", fontSize: 13, background: "var(--surface2)",
            color: "var(--text2)", fontFamily: "var(--font)" }}>Cancelar</button>
        <button className="btn" onClick={enviar} disabled={!coincide || enviando}
          title={coincide ? "" : "Escribe el nombre exacto para poder borrarlo"}
          style={{ padding: "8px 16px", borderRadius: 9, border: "none",
            cursor: coincide && !enviando ? "pointer" : "not-allowed",
            fontSize: 13, fontWeight: 600, fontFamily: "var(--font)",
            background: "var(--danger)", color: "var(--on-danger)", opacity: coincide && !enviando ? 1 : .45 }}>
          {enviando ? "Borrando..." : "Borrar definitivamente"}
        </button>
      </div>
    </div>
  );
}
